import { observer } from "mobx-react-lite";
import { FormField } from "../../../../../../components/form-field/form-field";
import { ButtonIcon } from "../../../../../../components/inputs/button-icon/button-icon";
import IconDelete from "../../../../../../components/icons/icon-delete/icon-delete";
import './rma-email-attachments.scss';
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../../components/fonts/font-props";
import { IRmaActionStore } from "../../../rma-types";

interface IProps {
    actionStore: IRmaActionStore;
}

const RmaEmailAttachments: React.FC<IProps> = observer(({ actionStore }) => {
    return (
        <FormField label="Uploaded files">
            <div>
                {actionStore.emailAttachments.map((emailAttachment, index) => (
                    <div className="rma-email-attachment" key={index}>
                        <FontBody1 color={FONT_COLOR.PRIMARY3_50}>{emailAttachment.name}</FontBody1>
                        <ButtonIcon Component={IconDelete} color={'var(--color-accent-1)'} onClick={() => actionStore.removeEmailAttachment(emailAttachment)} />
                    </div>
                ))}
            </div>
        </FormField>
    );
});

export default RmaEmailAttachments;